module.exports = __webpack_public_path__ + "static/media/twitter.79d08859.svg";